import { Link } from "react-router-dom";
import { useApi } from "@/lib/api";
import { useSeo } from "@/lib/site";
import { PageIntro } from "@/components/site/PageIntro";
import { ServiceCard } from "@/components/site/ServiceCard";

export default function SupportHub() {
  useSeo("Support", "Find someone to talk to. Trusted UK organisations supporting families and friends affected by addiction.");
  const { data: services } = useApi("/directory");
  const talk = (services || []).filter((s) => s.featured || s.support_types.includes("support-groups")).slice(0, 6);
  return (
    <>
      <PageIntro eyebrow="Support" title="You deserve support too." image="/images/circle.jpg" imageAlt="A small group of people sitting together on chairs outdoors" testId="support-intro">
        <p>Family members and friends can benefit from their own support, whether or not their loved one is seeking treatment or in recovery. Getting support for yourself isn't giving up on them. It's making sure you're not carrying this alone.</p>
      </PageIntro>

      <section className="container-site" aria-labelledby="talk-heading" data-testid="support-talk-section">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div className="max-w-2xl">
            <h2 id="talk-heading" className="text-3xl sm:text-4xl">Find someone to talk to</h2>
            <p className="mt-3 text-ink-soft">Established UK organisations offering support to families and friends. Addiction &amp; Us does not run its own helpline or staffed service.</p>
          </div>
          <Link to="/directory" className="btn-secondary shrink-0" data-testid="support-directory-btn">Full support directory</Link>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">{talk.map((s) => <ServiceCard key={s.slug} entry={s} />)}</div>
      </section>

      <section className="container-site mt-20" aria-labelledby="more-help-heading" data-testid="support-more-help-section">
        <div className="rounded-[2.5rem] bg-white/70 border border-ink/10 p-6 sm:p-10 max-w-4xl">
          <h2 id="more-help-heading" className="text-3xl sm:text-4xl">Can't find what you need?</h2>
          <p className="mt-4 text-ink-soft">Addiction &amp; Us can't respond to personal situations, but the organisations in our directory can. Many offer free, confidential helplines, groups and one-to-one support for families and friends.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/directory" className="btn-primary" data-testid="support-more-directory-btn">Browse the support directory</Link>
            <Link to="/find-your-way" className="btn-secondary" data-testid="support-more-journeys-btn">Find Your Way</Link>
            <Link to="/urgent-help" className="btn-secondary" data-testid="support-more-urgent-btn">Urgent help</Link>
          </div>
        </div>
      </section>
    </>
  );
}
